export type NewsArticleMeta = {
  slug: string;
  title: string;
  date: string;
  author: string;
  excerpt: string;
  metaTitle: string;
  metaDescription: string;
};

export const newsArticles: NewsArticleMeta[] = [
  {
    slug: "toothache-at-night-book-dentist-broadmeadows-glenroy",
    title: "Toothache at Night? Here's What to Do — and How to Book a Dentist in Broadmeadows or Glenroy First Thing Tomorrow Morning",
    date: "April 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Throbbing toothache keeping you up? Learn safe home relief for tonight, when to go to hospital, and how to secure a first-available morning appointment at Y3 Smiles. Emergency consult from $65.",
    metaTitle: "Toothache Tonight? Book a Broadmeadows or Glenroy Dentist for Tomorrow",
    metaDescription:
      "Tooth pain at night near Broadmeadows or Glenroy? Here's what to do right now, safe home relief tips, and how to book your first available morning appointment online. Consult from $65.",
  },
  {
    slug: "teeth-whitening-broadmeadows-glenroy-in-chair-vs-take-home",
    title: "Professional Teeth Whitening in Broadmeadows & Glenroy: In-Chair vs Take-Home — Which Option Is Right for You?",
    date: "April 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Coffee, tea, red wine, and ageing all stain teeth. Compare professional in-chair and take-home whitening, understand what OTC strips can and can't do, and learn what to expect. From $399 with Afterpay.",
    metaTitle: "Teeth Whitening Broadmeadows & Glenroy | From $399 | Y3 Smiles",
    metaDescription:
      "Professional teeth whitening near Broadmeadows and Glenroy from $399. Compare in-chair and take-home options. Afterpay available. Book a whitening consultation online today.",
  },
  {
    slug: "how-often-dental-check-up-broadmeadows-glenroy",
    title: "How Often Should You Get a Dental Check-Up? The Honest Answer from Your Broadmeadows and Glenroy Dentist",
    date: "April 2026",
    author: "Dr Fatima Kurnaz",
    excerpt:
      "Is 'every 6 months' actually right for you? We explain what current evidence says, which risk factors affect recall intervals, and what to expect at a check-up and clean. From $229 at Y3 Smiles.",
    metaTitle: "How Often Should You See a Dentist? | Broadmeadows & Glenroy | Y3 Smiles",
    metaDescription:
      "The 'every 6 months' rule is not right for everyone. Our Broadmeadows and Glenroy dentists explain how often you actually need a check-up. Check & clean from $229.",
  },
  {
    slug: "wisdom-teeth-removal-broadmeadows-glenroy",
    title: "Wisdom Teeth Removal in Broadmeadows & Glenroy: What to Expect, How Much It Costs, and When You Actually Need It",
    date: "April 2026",
    author: "Dr Fatima Kurnaz",
    excerpt:
      "Waking up with jaw pain? Wisdom teeth problems affect most Australians. Our guide covers impaction types, warning signs, the removal process, recovery, and costs from $250 at Y3 Smiles Dental.",
    metaTitle: "Wisdom Teeth Removal Broadmeadows & Glenroy | From $250 | Y3 Smiles",
    metaDescription:
      "Wisdom tooth pain near Broadmeadows or Glenroy? Our guide covers signs you need removal, the procedure, recovery, and costs from $250. Book a consultation online.",
  },
  {
    slug: "does-my-child-qualify-free-dental-cdbs-broadmeadows",
    title: "Does My Child Qualify for Free Dental? A Complete Guide to the Child Dental Benefits Schedule (CDBS) for Northern Melbourne Families",
    date: "April 2026",
    author: "Dr Fatima Kurnaz",
    excerpt:
      "Is your child eligible for up to $1,158 in free dental care? Learn who qualifies for the CDBS, what it covers, and how to book at Y3 Smiles Dental in Broadmeadows.",
    metaTitle: "Free Kids Dental in Broadmeadows & Glenroy | CDBS Guide | Y3 Smiles",
    metaDescription:
      "Is your child eligible for up to $1,158 in free dental care? Our northern Melbourne CDBS guide covers eligibility, what is covered, and how to book. Kids check & clean from $99.",
  },
  {
    slug: "dr-fatima-kurnaz-broadmeadows",
    title: "Dr Fatima Kurnaz — A Proud Turkish Australian Dentist Coming Home to Broadmeadows",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Meet Dr Fatima Kurnaz, Melbourne University–trained DDS, bilingual Turkish dentist, and founder of Y3 Smiles Dental—serving the Broadmeadows community she grew up in.",
    metaTitle: "Turkish Dentist in Broadmeadows | Dr Fatima Kurnaz (DDS Melbourne)",
    metaDescription:
      "Meet Dr Fatima Kurnaz, Melbourne University–trained DDS, bilingual Turkish dentist, and founder of Y3 Smiles Dental—serving the Broadmeadows community she grew up in.",
  },
  {
    slug: "dental-check-up-vs-clean",
    title: "Dental Check-Up vs Dental Clean: What’s the Difference and Why You Need Both",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Learn the difference between a dental check-up and a professional clean, including pros, cons, and indicative costs in Australia.",
    metaTitle: "Dental Check-Up vs Clean in Broadmeadows | Y3 Smiles Dental",
    metaDescription:
      "Learn the difference between a dental check-up and a professional clean, including pros, cons, and costs in Australia. Trusted Broadmeadows dentist.",
  },
  {
    slug: "filling-vs-root-canal-vs-extraction",
    title: "Filling vs Root Canal vs Tooth Extraction: Which Dental Treatment Is Right for Tooth Pain?",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Compare dental fillings, root canal treatment, and tooth extraction, with pros, cons, and indicative Australian costs.",
    metaTitle: "Tooth Pain Treatment Options | Broadmeadows Dentist",
    metaDescription:
      "Compare dental fillings, root canal treatment, and tooth extraction. Learn pros, cons, and Australian costs from a trusted Broadmeadows dental clinic.",
  },
  {
    slug: "kids-dental-check-ups-early-care",
    title: "Kids Dental Check-Ups vs Waiting for Pain: Why Early Oral Care Matters",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Why early dental check-ups for children prevent decay and anxiety, with CDBS eligibility and benefits.",
    metaTitle: "Kids Dentist Broadmeadows | Early Dental Care Guide",
    metaDescription:
      "Learn why early dental check-ups for children prevent decay and anxiety. Includes Medicare CDBS eligibility and benefits.",
  },
  {
    slug: "teeth-whitening-vs-veneers",
    title: "Teeth Whitening vs Veneers: Cosmetic Dentistry Options Explained",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Compare teeth whitening and veneers, including benefits, risks, and Australian price ranges.",
    metaTitle: "Teeth Whitening vs Veneers | Broadmeadows Cosmetic Dentist",
    metaDescription:
      "Compare teeth whitening and veneers, including benefits, risks, and Australian price ranges.",
  },
  {
    slug: "implants-dentures-bridges",
    title: "Dental Implants vs Dentures vs Bridges: Replacing Missing Teeth",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Compare dental implants, dentures, and bridges with costs, pros, cons, and suitability.",
    metaTitle: "Missing Teeth Options Broadmeadows | Implants vs Dentures",
    metaDescription:
      "Compare dental implants, dentures, and bridges. Learn costs, pros, cons, and suitability.",
  },
  {
    slug: "braces-vs-clear-aligners",
    title: "Braces vs Clear Aligners: Orthodontic Options for Kids and Adults",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Compare braces and clear aligners for children and adults, including suitability and lifestyle factors.",
    metaTitle: "Braces vs Invisalign Broadmeadows | Orthodontic Guide",
    metaDescription:
      "Compare braces and clear aligners for children and adults, including suitability and lifestyle factors.",
  },
  {
    slug: "managing-dental-anxiety-in-children",
    title: "Managing Dental Anxiety in Children: A Gentle Dentistry Approach",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "How child-focused dentistry reduces dental anxiety and builds lifelong oral health habits.",
    metaTitle: "Gentle Kids Dentist Broadmeadows | Dental Anxiety Help",
    metaDescription:
      "How child-focused dentistry reduces dental anxiety and builds lifelong oral health habits.",
  },
  {
    slug: "gum-disease-vs-cavities",
    title: "Gum Disease vs Cavities: What’s the Difference and Why It Matters",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Learn the difference between gum disease and cavities, including symptoms, risks, and treatment costs.",
    metaTitle: "Gum Disease Treatment Broadmeadows | Dentist Near You",
    metaDescription:
      "Learn the difference between gum disease and cavities, including symptoms, risks, and treatment costs.",
  },
  {
    slug: "dental-treatment-costs-australia",
    title: "How Much Does Dental Treatment Cost in Australia? A Practical Guide",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Understand typical dental costs in Australia and how early care saves money long-term.",
    metaTitle: "Dental Costs in Australia | Broadmeadows Dentist Guide",
    metaDescription:
      "Understand typical dental costs in Australia and how early care saves money long-term.",
  },
  {
    slug: "dental-payment-options-australia",
    title: "Dental Payment Options in Australia: How to Manage Treatment Costs",
    date: "February 2026",
    author: "Y3 Smiles Dental",
    excerpt:
      "Explore dental payment options in Australia, including Medicare, private health, and payment plans.",
    metaTitle: "Dental Payment Plans Broadmeadows | Y3 Smiles Dental",
    metaDescription:
      "Explore dental payment options in Australia, including Medicare, private health, and payment plans.",
  },
];
